import ResourceBrowserSearchButton from "../ResourceBrowserSearchButton/ResourceBrowserSearchButton";
import styles from "./ResourceBrowserTabsContainer.module.css";

function ResourceBrowserTabsContainer({
    activeTab,
    setActiveTab,
    tabs,
    setSearchValue,
    searchActive,
}) {
    function handleCloseButton() {
        setActiveTab(tabs[0] ?? "");
    }

    return (
        <div className={styles.tabs_container}>
            <ResourceBrowserSearchButton
                setActiveTab={setActiveTab}
                onClick={() => setActiveTab("Search")}
                searchActive={searchActive}
                setSearchValue={setSearchValue}
                handleCloseButton={handleCloseButton}
            />
            <div
                className={[
                    styles.tabs_scroll_container,
                    "hide-scrollbar",
                ].join(" ")}
            >
                <div className={styles.tabs_overflow_container}>
                    {tabs.map((tabName) => (
                        <button
                            key={tabName}
                            onClick={() => setActiveTab(tabName)}
                            className={[
                                styles.tab_button,
                                activeTab === tabName
                                    ? styles.active_tab_button
                                    : "",
                            ].join(" ")}
                        >
                            {tabName}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ResourceBrowserTabsContainer;
